import listActions from 'src/modules/responsibleConsumption/list/responsibleConsumptionListActions';
import ResponsibleConsumptionService from 'src/modules/responsibleConsumption/responsibleConsumptionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import Message from 'src/view/shared/message';
import { navigateTo } from 'src/view/shared/routes/helpers';
import { AppDispatch } from 'src/modules/store';

const prefix = 'RESPONSIBLECONSUMPTION_DESTROY';

const responsibleConsumptionDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: id => async (dispatch: AppDispatch) => {
    try {
      dispatch({
        type: responsibleConsumptionDestroyActions.DESTROY_STARTED,
      });

      await ResponsibleConsumptionService.destroyAll([id]);

      dispatch({
        type: responsibleConsumptionDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(i18n('entities.responsibleConsumption.destroy.success'));

      dispatch(listActions.doFetchCurrentFilter());

      navigateTo('/library/responsible-consumption');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: responsibleConsumptionDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: ids => async (dispatch: AppDispatch) => {
    try {
      dispatch({
        type: responsibleConsumptionDestroyActions.DESTROY_ALL_STARTED,
      });

      await ResponsibleConsumptionService.destroyAll(ids);

      dispatch({
        type: responsibleConsumptionDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.responsibleConsumption.destroyAll.success'),
      );

      navigateTo('/library/responsible-consumption');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: responsibleConsumptionDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default responsibleConsumptionDestroyActions;
